import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const CallToActionStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      color: "white",
      minHeight: "96px",
      width: "100%",
      borderRadius: "15px",
      display: "flex",
      flexDirection: "column",
      padding: "25px",
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
      },
    },
    title: {
      marginBottom: "4px",
      fontSize: "14px",
    },
    bold: {
      fontWeight: theme.typography.fontWeightBold,
    },
    link: {
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: theme.typography.fontWeightBold,
      color: "#FFF",
      textTransformColor: "#FFF",
    },
    dismiss: {
      display: "none",
    },
  }),
);
